import { gaReportQualifiedTune } from '../utils/gaTracking';
import { QUALIFIED_TUNE } from '../../common/actions/tuner';

export default () => (next) => (action) => {
  if (action.type === QUALIFIED_TUNE) {
    gaReportQualifiedTune();
  }

  return next(action);
};
